
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form4DataInfoType } from '@/types/Information/Form4';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form4Layout extends Vue {

    @Prop({required:true})
    result!: form4DataInfoType;

    dataReady = false;
    rules = '';

    mounted(){
        this.dataReady = false;
        // if (this.result.selfRepresented){

        //     const ruleList = [];
        //     for (const rule of this.result.relyingSectionRule){                
        //         if (rule == 'Other' && this.result.otherRelyingSectionRule){
        //             ruleList.push(this.result.otherRelyingSectionRule);
        //         } else {
        //             ruleList.push(rule);
        //         }
        //     }
        //     this.rules = ruleList.join(', ');

        // } else {
        //     this.rules = this.result.lawyerRelyingSectionRule;
        // }
        this.dataReady = true;
    }
}

